module.exports = __webpack_public_path__ + "img/small-nofile.eedfb848.png";